import Box from '@mui/material/Box';
import { useRef } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Roi } from '~/domain/dicom/dicomstructureset';
import useRoi from '~/hooks/structure-set/useRoi';
import {
    openedROIPropertiesOverlayState,
    selectedROIState,
} from '~/state/atoms/structureSet/roiAtoms';
import StructureDeletionConfirmationDialog from './StructureDeletionConfirmationDialog';
import StructureField from './StructureProperties';
import ROIPropertiesOverlay from './StructureProperties/StructurePropertiesOverlay';

export default function StructureLayer({
    roi,
    onDelete,
    menuRef,
}: {
    roi: Roi;
    onDelete: (roiNumber: number, sopUid: string) => void;
    menuRef?: React.RefObject<HTMLElement | undefined>;
}) {
    const roiFieldRef = useRef<HTMLDivElement | null>(null);
    const selectedROI = useRecoilValue<number>(selectedROIState);
    const [visibleRoiProperties, setVisibleRoiProperties] = useRecoilState(
        openedROIPropertiesOverlayState
    );
    const ROINumber = roi.roiNumber;
    const isSelected = selectedROI === ROINumber;
    const { structureCanBeDeleted } = useRoi(roi);

    return (
        <Box
            ref={roiFieldRef}
            display="flex"
            alignItems="center"
            sx={(theme) => ({
                background: isSelected
                    ? theme.palette.primary.contrastText
                    : 'none',
            })}
        >
            <StructureField roi={roi} />
            {isSelected && (
                <ROIPropertiesOverlay
                    open={visibleRoiProperties}
                    onClose={() => setVisibleRoiProperties(false)}
                    roi={roi}
                    anchorEl={menuRef?.current}
                />
            )}
            {structureCanBeDeleted && (
                <StructureDeletionConfirmationDialog
                    roi={roi}
                    isSelected={isSelected}
                    onDelete={onDelete}
                />
            )}
        </Box>
    );
}
